import { render, staticRenderFns } from "./atendimentoAntecipado.vue?vue&type=template&id=26c547b8"
import script from "./atendimentoAntecipado.vue?vue&type=script&lang=js"
export * from "./atendimentoAntecipado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports